<template>
  <es-popup show="{{visible}}">
    <view wx:if="{{visible}}" class="container">
      <image bindtap="close" class="close-btn" src="https://ut-static.udache.com/webx/sfc/P9wPVGyKIwjrgsIB2p7Mz_clipboard_image_1698901019945.png" mode="widthFix"></image>
      <view class="title">补全身份信息</view>
      <view class="subtitle">证件信息已过期，补全后方可购票</view>
      <view class="user">
        <view class="name">{{supplyInfo.passenger_name}}</view>
        <view class="idtype">{{supplyInfo.id_name}}</view>
      </view>
      <input
        type="idCard"
        class="idno"
        placeholder="请输入身份证"
        wx:model="{{keywords}}"
        maxlength="{{18}}"
      />
      <view class="submit" bindtap="confirm">提交</view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      supplyInfo: {
        type: Object,
        value: () => {}
      }
    },
    data: {
      keywords: null,
    },
    computed: {
      visible() {
        return !!this.supplyInfo.id
      },
    },
    watch: {
      visible: {
        handler(val) {
          !val && (this.keywords = null)
        },
      }
    },
    methods: {
      close() {
        this.triggerEvent('close')
        this.keywords = null
      },
      confirm() {
        this.triggerEvent('confirm', {
          originData: this.supplyInfo,
          new_id_no: this.keywords ? this.keywords.trim() : ''
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
.container
  width 280px
  height 280px
  background-color #ffffff
  border-radius 15px
  padding 32px 20px 0
  box-sizing border-box
  position relative
  line-height 1
  font-family PingFangSC-Regular
  font-weight 400
  .close-btn
    position absolute
    width 18px
    height 18px
    top 12px
    right 12px
  .title
    font-family PingFangSC-Medium
    font-size 20px
    font-weight 500
    text-align center
    color #333333
    margin-bottom 10px
  .subtitle
    font-size 12px
    text-align center
    color #999
    margin-bottom 32px
  .user
    @extend .flex-center
    height 16px
    .name
      font-family PingFangSC-Medium
      font-weight 500
      font-size 16px
      color #333333
    .idtype
      font-size 20px
      color #999
      padding 2px 4px
      border 1px solid #CCCCCC
      border-radius 4px
      transform scale(0.5)
      transform-origin 0 50%
      margin-left 6px
  .idno
    font-size 16px
    height 44px
    outline none
    background-color #F6F8FB
    margin-top 10px
    border-radius 8px
    padding-left 14px
    box-sizing border-box
    caret-color #FF6400
    &::placeholder
      color #ccc
  .submit
    @extend .flex-center
    justify-content center
    height 44px
    background-color #FF6400
    font-family PingFangSC-Medium
    font-weight 500
    font-size 16px
    border-radius 8px
    color #fff
    margin-top 32px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'es-popup': '@didi/es-mpx-ui/lib/popup'
    }
  }
</script>
